<template>
  <button
    type="button"
    data-test-id="go-to-digital-id"
    class="digital-id header-actions-icon"
    :aria-label="$t('sidebar_items.digital_id')"
    @click="goToDigitalID"
  >
    <span
      class="fi flaticon-profile-line content-center"
      aria-hidden="true"
    ></span>
  </button>
</template>

<script>
export default {
  name: "TheHeaderDigitalID",
  data() {
    return {}
  },
  computed: {},
  methods: {
    goToDigitalID() {
      this.$router.push("/id-card")
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/v3scss/_variables.scss";

.digital-id {
  color: $gray-darken-40;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;

  .fi {
    font-size: 22px;
    line-height: 1;
  }
}
</style>
